import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Platform } from '@ionic/angular/standalone';
import { Api } from 'src/app/core/common/api';
import { IVersionResult, VersionStatus } from 'src/app/core/contracts';
import { UI } from 'src/app/core/helpers/ui';
import { environment } from 'src/environments/environment';

@Injectable()
export class UpdateHandler {
  private platform = inject(Platform);
  private api = inject(Api);
  private ui = inject(UI);
  private browser = inject(InAppBrowser);

  public checkForUpdate() {
    if (!this.platform.is('capacitor')) {
      // if it's a web app then it's already up to date!
      return;
    }
    const platform = this.platform.is('ios') ? 'ios' : 'android';
    const params = new HttpParams().set('platform', `${platform}`).set('versionCode', `${environment.version}`);
    this.api
      .get<IVersionResult>(`version/status`, {
        params,
        handleError: false,
        handleLoading: false,
      })
      .subscribe((result: IVersionResult) => {
        switch (result.status) {
          case VersionStatus.UpdateRequired:
          case VersionStatus.UpdateRecommended:
            if (result.updateUrl) {
              this.showDialog(result);
            }
            break;
          default:
            // no update, app is up to date
            break;
        }
      });
  }
  private showDialog(result: IVersionResult) {
    // allow dismiss only if update is optional
    const canDismiss: boolean = result.status === VersionStatus.UpdateRecommended;
    this.ui.showUpdateDialog(canDismiss).then(update => {
      if (update) {
        const updateUrl = result.updateUrl;
        this.browser.create(updateUrl, '_system');
      }
    });
  }
}
